import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { ZINDEX, COLORS3, FONT, MEDIA_QUERY, SPACING } from '../../styles/emotion';
import { Tooltip } from '../Tooltip';

export const CopyTooltip = styled(Tooltip)<{ popIn?: boolean }>`
  display: none;
  position: absolute;
  transform: translate(-50%, 50%);

  ${(props) =>
    props.popIn &&
    `
      z-index: ${ZINDEX.super};
    `}

  .tooltip, .tooltip__container {
    ${FONT.textSizeCompact(FONT.SIZE.EXTRA_SMALL)}
    cursor: default;
    height: auto;
    width: auto;
    width: 150px;
  }

  .tooltip::before {
    left: 0;
    opacity: 1;
    position: absolute;
    bottom: -3px !important;
    visibility: visible;
  }
  .tooltip::after {
    display: none;
  }
`;

export const PreviewWebsiteTooltip = styled(CopyTooltip)`
  top: -56px;
  left: 11px;
`;

export const Segment = styled.button<{
  isActive?: boolean;
  shouldHide?: boolean;
  lightVariantStyling?: boolean;
}>`
  border: none;
  background-color: transparent;
  color: ${COLORS3.BLACK_050};
  cursor: pointer;
  display: flex;
  font-size: ${FONT.FONT_SIZE_SMALLER};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  line-height: 28px;
  text-align: center;
  z-index: 1;
  transition: color 0.3s ease;
  outline: revert;
  border-radius: 100px;
  position: relative;
  ${(props) =>
    props.isActive &&
    `
      color: ${props.lightVariantStyling ? `${COLORS3.BLACK_100}` : `${COLORS3.WHITE_100}`};
    `};
  ${(props) =>
    props.shouldHide &&
    `
      display: none;
    `};
  ${MEDIA_QUERY.MOBILE} {
    min-width: 96px;
  }
  ${MEDIA_QUERY.MOBILE_XS} {
    min-width: fit-content;
  }
  &:hover {
    ${PreviewWebsiteTooltip} {
      display: block;
    }
  }
`;

export const SegmentControl = styled.div<{
  ready?: boolean;
  activeWidth?: number;
  activeTranslateX?: number;
  iconOnlyStyling?: boolean;
  lightVariantStyling?: boolean;
  compactHeight?: boolean;
}>`
  border-radius: 120px;
  display: flex;
  justify-content: center;
  padding: ${SPACING.S4};
  width: fit-content;
  position: relative;
  ${(props) =>
    !props.iconOnlyStyling &&
    !props.compactHeight &&
    `
    height: 44px;
    margin: 0 auto 20px;
    `};
  ${(props) =>
    props.lightVariantStyling
      ? `
    background-color: ${COLORS3.BLACK_005};
    `
      : `
      border: 1px solid ${COLORS3.BLACK_100};
    `};
  ${(props) =>
    props.ready &&
    `
    &::before {
      content: '';
      background-color: ${
        props.lightVariantStyling ? `${COLORS3.WHITE_100}` : `${COLORS3.BLACK_100}`
      };
      border-radius: 100px;
      width: ${props.activeWidth ? `${props.activeWidth}px` : '0'};
      transform: translateX(
        ${props.activeTranslateX ? `${props.activeTranslateX}px` : '0'}
      );

      position: absolute;
      top: 2px;
      bottom: 2px;
      left: 0;
      right: 0;
      z-index: 0;
      transition: transform 0.3s ease, width 0.3s ease;
    }
  `}

  ${Segment} {
    height: ${({ iconOnlyStyling }) => (iconOnlyStyling ? '40px' : 'unset')};
    padding: ${({ iconOnlyStyling }) => (iconOnlyStyling ? '0 12px' : '0 10px')};
    ${(props) =>
      !props.iconOnlyStyling &&
      !props.compactHeight &&
      `
      min-width: 135px;
    `};
  }
`;

export const IconCss = css`
  margin-right: 4px;
  display: flex;
`;
